import { createFileRoute, redirect } from '@tanstack/react-router';

import { ReportPrintPage } from '@/features/reports/print-page';
import { bootSession } from '@/lib/auth/session';

/** Outside the app shell on purpose: a clean page for the browser's print / Save as PDF. */
export const Route = createFileRoute('/print/org/$orgId/reports/$reportKey')({
  beforeLoad: async ({ location }) => {
    const session = await bootSession();
    if (session.status === 'signed_out') {
      throw redirect({ to: '/signin', search: { return_to: location.href } });
    }
  },
  component: PrintRoute,
});

function PrintRoute() {
  const { orgId, reportKey } = Route.useParams();
  return <ReportPrintPage scope={{ kind: 'org', id: orgId }} reportKey={reportKey} range={{}} />;
}
